/** localStorage key holding the address this browser last asked for a sign-in link with. */
export const SIGN_IN_LINK_EMAIL_KEY = 'wh:sign-in-link-email';

/**
 * The address a sign-in link was sent to from this device, so opening the link here signs in without asking for it.
 * Never throws: storage that is blocked, full or missing counts as empty.
 */
export interface SignInLinkEmailStore {
  read: () => string | undefined;
  save: (email: string) => void;
  clear: () => void;
}

type LinkEmailStorage = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>;

/** A store over `storage()`, which is called on every access and may throw (window.localStorage can). */
export const createSignInLinkEmailStore = (storage: () => LinkEmailStorage | undefined): SignInLinkEmailStore => ({
  read: () => {
    try {
      return storage()?.getItem(SIGN_IN_LINK_EMAIL_KEY) || undefined;
    } catch {
      return undefined;
    }
  },
  save: (email) => {
    try {
      storage()?.setItem(SIGN_IN_LINK_EMAIL_KEY, email);
    } catch {
      // Opening the link will ask for the address instead.
    }
  },
  clear: () => {
    try {
      storage()?.removeItem(SIGN_IN_LINK_EMAIL_KEY);
    } catch {
      // Nothing could be stored either.
    }
  },
});

export const browserSignInLinkEmailStore = createSignInLinkEmailStore(() => window.localStorage);
